import {
  GroupBase as DefaultGroupBase,
  DropdownIndicatorProps,
  components,
} from 'react-select';
import { useTheme } from 'styled-components';
import { DropdownIndicatorIcon } from '../DropdownSelect.styles';
import { DefaultOption } from './DropdownOptions';

export const DropdownIndicator = <
  Option extends DefaultOption = DefaultOption,
  GroupBase extends DefaultGroupBase<Option> = DefaultGroupBase<Option>,
>({
  ...props
}: DropdownIndicatorProps<Option, boolean, GroupBase> & {
  buttonVariant?: 'primary' | 'secondary' | 'tertiary';
}) => {
  const theme = useTheme();
  const { disabled } = props.selectProps;
  const buttonVariant = props.buttonVariant;

  return (
    <components.DropdownIndicator {...props}>
      <DropdownIndicatorIcon
        className="uil uil-angle-down"
        color={theme.atlas.semantic.color.type.default}
        size="24px"
        disabled={disabled}
        buttonVariant={buttonVariant}
      />
    </components.DropdownIndicator>
  );
};
